import React from 'react';
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';

// CONSTANTS AND DESTRUCTURING
// ================================================================
const Option = Select.Option;
const FormItem = Form.Item;

const OptionColor = ({ color }) => {
  const style = {
    verticalAlign: 'middle',
    marginRight: 3,
    display: 'inline-block',
    height: 10,
    width: 10,
    borderRadius: '50%',
    backgroundColor: color,
  };
  return <div style={style} />;
};

// EXPORTED COMPONENT
// ================================================================
const SessionCategoryInput = props => {
  const optionChildren = props.sessionTypes.length
    && props.sessionTypes.length > 0
    && props.sessionTypes.map(item => (
      <Option key={item._id} value={item._id}>
        <OptionColor color={item.color} />
        {item.title}
      </Option>
    ));

  return (
    <Select
      size="large"
      showSearch
      optionFilterProp="children"
      filterOption={GeneralHelpers.selectSearchFilter}
      {...props}
      style={{ width: '100%', ...props.style }}
    >
      {!props.sessionTypes || props.sessionTypes.length === 0 ? 'Loading...' : optionChildren}
    </Select>
  );
};

// EXPORT
// ================================================================
export default SessionCategoryInput;



// WEBPACK FOOTER //
// ./src/components/inputs/SessionCategoryInput/index.js